import { DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  InputNumber,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import GenericTable from "../../components/Commons/Table/generic-table.component";
import { useQuery } from "react-query";
import ConfirmModal from "../../components/Commons/Modal/confirm-modal.component";
import { isMobile } from "react-device-detect";
import { formatCurrency } from "../../services/utils";

const { Text } = Typography;

interface PropsServices {
  saleServices: any;
  onRemoveService: any;
  services: any[];
  onUpdateSaleService: any;
  totalServices: any;
}

export default function ListServices({
  saleServices,
  onRemoveService,
  services,
  onUpdateSaleService,
  totalServices,
}: PropsServices) {
  const [listServices, setListServices] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("");
  const [removeServiceId, setRemoveServiceId] = useState<number | undefined>(
    undefined
  );

  const { refetch: refreshListServices } = useQuery(
    ["loadServices", search],
    () => {
      let list = saleServices.map((service: any) => {
        return {
          key: service.service_id,
          ...service,
        };
      });

      if (search.length) {
        list = list.filter((service: any) =>
          service.label.toLowerCase().includes(search.toLowerCase())
        );
      }

      setListServices(list);
    },
    { refetchOnWindowFocus: false }
  );

  const onFilterServices = (
    input: string,
    option?: { key: string; value: number; children: [] }
  ) =>
    (option?.children.join("") ?? "")
      .toLowerCase()
      .includes(input.toLowerCase());

  const renderPrice = (record: any) => {
    return (
      <InputNumber
        value={record.price}
        min={0.1}
        placeholder="Insira o preço"
        size="large"
        maxLength={5}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
        onBlur={(event) => {
          let newValues = { ...record };
          newValues.price = event.target.value;

          onUpdateSaleService(record.service_id, newValues);
        }}
      />
    );
  };

  const renderQuantity = (record: any) => {
    return (
      <InputNumber
        value={record.quantity}
        min={1}
        placeholder="Insira a Quantidade"
        size="large"
        maxLength={5}
        onBlur={(event) => {
          let newValues = { ...record };
          newValues.quantity = event.target.value;
          onUpdateSaleService(record.service_id, newValues);
        }}
      />
    );
  };

  const renderTotal = (record: any) => {
    return (
      <InputNumber
        value={record.price * record.quantity}
        placeholder="Total"
        size="large"
        disabled={true}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
      />
    );
  };

  const columns: any = [
    {
      title: "Serviço",
      dataIndex: "service",
      sorter: false,
      key: "service",
      width: 545,
      render: (_: any, record: any) => (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Select
            showSearch
            placeholder="Serviço"
            style={{ width: "100%" }}
            size="large"
            value={record.service_id}
            filterOption={onFilterServices}
            onChange={(value) => {
              let newValues = { ...record };
              newValues.service_id = value;

              let _service = services.find((item) => item.value == value);
              newValues.price = _service.price;

              onUpdateSaleService(record.service_id, newValues);
            }}
          >
            {services.map((service) => (
              <Select.Option
                key={service.value}
                value={service.value}
                disabled={saleServices.some(
                  (item: any) =>
                    item.service_id == service.value &&
                    item.service_id != record.value
                )}
              >
                {service.label}
              </Select.Option>
            ))}
          </Select>
          {isMobile && (
            <Space>
              <Space direction="vertical">
                <Text strong>Preço</Text>
                {renderPrice(record)}
              </Space>
              <Space direction="vertical">
                <Text strong>Quantidade</Text>
                {renderQuantity(record)}
              </Space>
            </Space>
          )}
        </Space>
      ),
      responsive: ["xs", "sm", "md", "lg", "xl"],
    },
    {
      title: "Preço",
      dataIndex: "price",
      key: "price",
      width: 180,
      render: (_: any, record: any) => renderPrice(record),
      responsive: ["lg", "xl"],
    },
    {
      title: "Quantidade",
      dataIndex: "quantity",
      key: "quantity",
      width: 180,
      render: (_: any, record: any) => renderQuantity(record),
      responsive: ["lg", "xl"],
    },
    {
      title: "Subtotal",
      dataIndex: "total",
      key: "total",
      width: 180,
      render: (_: any, record: any) => renderTotal(record),
      responsive: ["lg", "xl"],
    },
    {
      title: "Ações",
      key: "action",
      width: 50,
      render: (_: any, record: any) => (
        <Space size="small">
          <Tooltip placement="top" title="Apagar">
            <Button
              onClick={() => setRemoveServiceId(record.service_id)}
              type="default"
              shape="circle"
              size="middle"
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    refreshListServices();
  }, [saleServices]);

  return (
    <>
      <Row gutter={20}>
        <Col span={24}>
          <GenericTable
            columns={columns}
            dataSource={listServices}
            loading={false}
            footer={() => (
              <Space
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: !saleServices.length
                    ? "space-between"
                    : "flex-end",
                }}
              >
                {!saleServices.length && (
                  <Text strong type="danger">
                    É necessário adicionar ao menos 1 (um) serviço.
                  </Text>
                )}
                <Text strong>Total: {formatCurrency(totalServices || 0)}</Text>
              </Space>
            )}
          />

          <ConfirmModal
            open={!!removeServiceId}
            title="Tem certeza que deseja apagar esse serviço?"
            okText="Apagar"
            cancelText="Voltar"
            onOk={() => {
              onRemoveService(removeServiceId);
              setRemoveServiceId(undefined);
            }}
            onCancel={() => setRemoveServiceId(undefined)}
          ></ConfirmModal>
        </Col>
      </Row>
    </>
  );
}
